import { IOrderTemplate } from 'Order/types/orderTemplate';

export const sortTemplatesPutDefaultFirst = (templates: IOrderTemplate[]) => {
  return templates.sort((a, b) => {
    if (a.attributes.isDefault) return -1;
    if (b.attributes.isDefault) return 1;
    return 0;
  });
};
